var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.user)?_c('AddUserFrom',{attrs:{"service-place-id":_vm.ServicePlaceId,"branch-id":_vm.BranchId,"rank":this.rank},on:{"userSaved":_vm.userSaved}}):_vm._e(),(_vm.user)?_c('UserHeader',{attrs:{"user":_vm.user}}):_vm._e(),(_vm.user)?_c('UserPermissions',{attrs:{"user":_vm.user},on:{"returnToUsers":_vm.returnToUsers}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }